import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import servicioUsuario from '../servicios/ServicioUsuario';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
class EditarContrasena extends Component{
    constructor(){
    super();
    this.state = {
    usuario:{},
    usuarioEditado:{},
    datosUsuario:{},
    errores:{}
    }
    }
    componentDidMount() {
    this.obtenerSession();
      }
      asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
      }
      obtenerSession = () => {
        servicioUsuario.bucarUsuarioSession().then(response => {
            console.log(response.data);
          this.setState({ usuario: response.data });
          this.setState({ datosUsuario: response.data });
        }).catch(error => {
           
        });
      }
      guardar = () => {
        const { usuarioEditado, usuario,datosUsuario} = this.state;

        const validacion = this.validarFormulario(usuarioEditado,datosUsuario);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            usuario.contrasena = usuarioEditado.contrasena;
            usuario.nombre = datosUsuario.nombre;
            usuario.correo = datosUsuario.correo;
            servicioUsuario.guardarContrasenaMiCuenta(usuario).then(response => {
                this.growl.show({ severity: 'success', summary: 'Exito', detail: 'Se cambio exitosamente la contraseña' });
              this.setState({ usuarioEditado: {}});
              localStorage.removeItem("auth");
              window.location = '/facturacionbanobras';
            }).catch(error => {
                this.growl.show({ severity: 'error', summary: 'Error', detail: 'No se cambio la contraseña' });
            });
        }
      }
      validarFormulario = (objeto, objeto2) => {
          const errores = {};
          var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
          var validacionCorreo = expreReg.exec(objeto2.correo);
          if (!objeto.contrasena)
          errores.contrasena = "La contraseña es requerida";
          if (!objeto.contrasena2)
          errores.contrasena2 = "La confirmación es requerida";
          if (objeto.contrasena !== objeto.contrasena2)
          errores.contrasena2 = "Las contraseñas no coinciden";
          if(!objeto2.nombre)
          errores.nombre ="El nombre es requerido";
          if(!objeto2.correo)
          errores.correo = "El correo es requerido";
          if(!validacionCorreo)
          errores.correo = "El correo no es valido";
        return errores;
      }


    render(){
        const { errores,usuarioEditado,datosUsuario } = this.state;
        return(
  <div>
        <Growl ref={(el) => this.growl = el} />
        <h1>Mi cuenta</h1>
        <div className="p-grid p-fluid">
        
        <div className="p-col-12 p-md-6">
       
            <h4>Nombre:</h4>
            <InputText id="nombre" name="datosUsuario.nombre" value={datosUsuario.nombre || ''} onChange={this.asignarValoresObjeto} className={errores.nombre ? 'p-error' : ''}/>
            {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-6">
       
            <h4>Correo:</h4>
            <InputText id="correo" name="datosUsuario.correo" value={datosUsuario.correo || ''} onChange={this.asignarValoresObjeto} className={errores.correo ? 'p-error' : ''}/>
            {errores.correo ? <div><br /> <Message severity="error" text={errores.correo} /> </div> : null}
          </div>
        </div>
       <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-6">
          <h4>Contraseña:</h4>
            <Password id="contrasena" name="usuarioEditado.contrasena" value={usuarioEditado.contrasena || ''} onChange={this.asignarValoresObjeto} className={errores.contrasena ? 'p-error' : ''}/>
            {errores.contrasena ? <div><br /> <Message severity="error" text={errores.contrasena} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-6">
          <h4>Confirmar Contraseña:</h4>
            <Password id="contrasena2" name="usuarioEditado.contrasena2" value={usuarioEditado.contrasena2 || ''} onChange={this.asignarValoresObjeto} className={errores.contrasena2 ? 'p-error' : ''}/>
            {errores.contrasena2 ? <div><br /> <Message severity="error" text={errores.contrasena2} /> </div> : null}
          </div>
        </div>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
            
          </div>
        </div>

        <div className="p-col ">
                <Button label="Aceptar" onClick={this.guardar} icon="pi pi-check" />
              </div>
     </div>
     
        );
    }
    

    
}
export default EditarContrasena;